import { render } from "./ProductChart.vue?vue&type=template&id=dd380156"
import script from "./ProductChart.vue?vue&type=script&lang=js"
export * from "./ProductChart.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Kevin\\Desktop\\ArbeitFinderundBeraterVersionen\\TvBerater\\FernseherBeraterUpdate05012026\\form_try0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__